import { TFunction } from '@lyearn/i18n';
import config from '@/modules/content/config';
import { PublishContentConfig, ResourceTypeEnum, ResourceVersionTypeEnum } from '@/types/schema';

type Props = {
  t: TFunction;
  type: ResourceTypeEnum;
  publishConfig?: PublishContentConfig;
  contentId?: string;
};

const getEditorSuccessMessage = ({ t, publishConfig, type, contentId }: Props) => {
  if (!publishConfig) {
    return t('Common:Form.DraftSavedSuccessfully');
  }

  const contentType = t(config[type].label.title);

  if (contentId && publishConfig.versionType === ResourceVersionTypeEnum.Major) {
    return t('Common:Form.ChangesPublishedSuccessfully');
  } else if (contentId && publishConfig.versionType === ResourceVersionTypeEnum.Minor) {
    return t('Common:Form.UpdatedExistingVersionSuccessfully');
  } else {
    return t('Common:Form.ContentTypePublishedSuccessfully', { contentType });
  }
};

export default getEditorSuccessMessage;
